import axios from 'axios';
// We import the encryption function we just created.
import { encryptPayload } from '../utils/crypto';

const DEFAULT_API_BASE_URL = 'https://api.netpad.click';

export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

// We create and export a single, shared instance of axios.
// All API calls in the app should use this instance.
export const instance = axios.create({
    baseURL: API_BASE_URL, // Your API base URL
    headers: {
        'Content-Type': 'application/json',
    }
});

const isFormDataPayload = (data) => {
    return typeof FormData !== 'undefined' && data instanceof FormData;
};

const removeContentTypeHeader = (headers) => {
    if (!headers) return;

    if (typeof headers.delete === 'function') {
        headers.delete('Content-Type');
        return;
    }

    delete headers['Content-Type'];
    delete headers['content-type'];
};

// Axios Request Interceptor: This function runs BEFORE every request is sent.
instance.interceptors.request.use(
    async (config) => {
        const isMultipartRequest = isFormDataPayload(config.data);
        if (isMultipartRequest) {
            removeContentTypeHeader(config.headers);
        }

        const isPublicKeyRequest = config.url?.endsWith('/crypto/public-key');
        const shouldEncrypt =
            Boolean(config.data) &&
            !isMultipartRequest &&
            config.method !== 'get' &&
            !isPublicKeyRequest;

        if (shouldEncrypt) {
            console.log(`Encrypting payload for: ${config.method.toUpperCase()} ${config.url}`);

            // 1. Encrypt the original data.
            const jweString = await encryptPayload(config.data);

            // 2. CRITICAL: Replace the original data with the new encrypted payload structure
            // that the backend's decryption middleware expects.
            config.data = {
                encryptedPayload: jweString,
            };
        }

        return config;
    },
    (error) => {
        // Handle request errors
        return Promise.reject(error);
    }
);
